/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import JobDescription from "components/JobDetailsComponent/JobDescription";
import { CircularProgress } from "@material-ui/core";
import Image from "next/image";
import LightBulbIcon from "components/RevampFeedDetails/assets/LightBulbIcon";
import ChevronLeftIcon from "assets/svgs/ChevronLeftIcon";
import InfoIcon from "components/RevampFeedDetails/assets/InfoIcon";
import { useWindowResize } from "utils/hooks";
import { getJobsQNA } from "utils/commonUtils";
import DownArrow from "assets/svgs/DownArrow";
import JobHighlightsCard from "./components/JobHighlightsCard";
import FeeChargeCard from "./components/FeeChargeCard";
import SimilarJobsSection from "../SimilarJobsSection";
import FAQs from "../FAQs";

const MOBILE_TABS = {
	JOB_DETAILS: "jobDetails",
	INTERVIEW_DETAILS: "interviewDetails",
	SIMILAR_JOBS: "similarJobs",
};

const Divider = () => (
	<div className="my-[24px] hidden h-[1px] w-full bg-[#E8E7EA] md:block" />
);

export const JobDetailsSection = ({
	jobDetails,
	jobDescription,
	shortJobDescription,
	jobDescriptionTemplate,
	similarJobs,
	category,
	similarJobsJoading,
	isCandidateEligible,
	isJobApplied,
	handleWalkInNudgeClick,
}) => {
	const [selectedTab, setSelectedTab] = useState(MOBILE_TABS.JOB_DETAILS);
	const [jobDetailsPosition, setJobDetailsPosition] = useState(null);
	const [interviewDetailsPosition, setInterviewDetailsPosition] = useState(null);
	const [similarJobsPosition, setSimilarJobsPosition] = useState(null);
	const [showQNASection, setShowQNASection] = useState(false);

	const jobDetailsRef = useRef(null);
	const interviewDetailsRef = useRef(null);
	const similarJobsRef = useRef(null);
	const isWalkInJob = jobDetails?.is_walk_in;
	const [isMobileView] = useWindowResize();
	const isExternalJob = jobDetails?.is_external_job;

	const handleTabClick = (value) => {
		setSelectedTab(value);

		if (value === MOBILE_TABS.JOB_DETAILS)
			if (jobDetailsPosition) {
				window.scrollTo({
					top: jobDetailsPosition.top - 110,
					left: jobDetailsPosition.left,
					behavior: "smooth",
				});
			}

		if (value === MOBILE_TABS.INTERVIEW_DETAILS)
			if (interviewDetailsPosition) {
				window.scrollTo({
					top: interviewDetailsPosition.top - 110,
					left: interviewDetailsPosition.left,
					behavior: "smooth",
				});
			}

		if (value === MOBILE_TABS.SIMILAR_JOBS)
			if (similarJobsPosition) {
				window.scrollTo({
					top: similarJobsPosition.top - 110,
					left: similarJobsPosition.left,
					behavior: "smooth",
				});
			}
	};

	const showJobHighLightsSection =
		Array.isArray(jobDetails?.job_highlights) &&
		jobDetails?.job_highlights?.length > 0;
	const showFeeChargeSection =
		jobDetails?.deposit?.amount ||
		(jobDetails?.deposit?.amount && jobDetails?.deposit?.purpose);
	const showdivider = showJobHighLightsSection || showFeeChargeSection;

	// Function to check if an element is in the viewport
	const isInViewport = (element) => {
		const rect = element.getBoundingClientRect();
		return rect.top >= 0 && rect.top <= window.innerHeight / 4;
	};

	// Function to handle scroll on window
	const handleWindowScroll = () => {
		if (jobDetailsRef?.current) {
			if (isInViewport(jobDetailsRef.current)) {
				setSelectedTab(MOBILE_TABS.JOB_DETAILS);
				return;
			}
		}

		if (interviewDetailsRef?.current) {
			if (isInViewport(interviewDetailsRef.current)) {
				setSelectedTab(MOBILE_TABS.INTERVIEW_DETAILS);
				return;
			}
		}

		if (similarJobsRef?.current) {
			if (isInViewport(similarJobsRef.current)) {
				setSelectedTab(MOBILE_TABS.SIMILAR_JOBS);
			}
		}
	};

	useEffect(() => {
		/*
			We have added a timeout for 100ms because when job details page loads,
			job description template is shown completely for 50ms. This behaviour is for SEO purposes.
			Without this timeout, the position of elements recorded will be incorrect.
			We record positions once page is rendered with final state.
		*/
		setTimeout(() => {
			// Set position of scroll to elements for accurate scrolling
			if (jobDetailsRef?.current) {
				const rect = jobDetailsRef?.current?.getBoundingClientRect();

				setJobDetailsPosition({
					top: rect.top + window.scrollY,
					left: rect.left + window.scrollX,
					width: rect.width,
					height: rect.height,
				});
			}
			if (interviewDetailsRef?.current) {
				const rect = interviewDetailsRef?.current?.getBoundingClientRect();

				setInterviewDetailsPosition({
					top: rect.top + window.scrollY,
					left: rect.left + window.scrollX,
					width: rect.width,
					height: rect.height,
				});
			}
			if (similarJobsRef?.current && !similarJobsJoading) {
				const rect = similarJobsRef?.current?.getBoundingClientRect();

				setSimilarJobsPosition({
					top: rect.top + window.scrollY,
					left: rect.left + window.scrollX,
					width: rect.width,
					height: rect.height,
				});
			}
		}, 100);

		// Add scroll event listener to change tabs on page scroll
		window.addEventListener("scroll", handleWindowScroll);
		return () => {
			window.removeEventListener("scroll", handleWindowScroll);
		};
	}, [similarJobsJoading]);

	return (
		<div className="rounded-0 border-[#E8E7EA] md:w-full md:max-w-[690px] md:overflow-hidden md:rounded-xl md:border md:border-solid md:bg-white">
			{/* Mobile Tabs for Job Details and Interview Details */}
			<div className="sticky top-[65px] z-[9] mt-[8px] flex  w-full  border border-solid bg-white text-center md:hidden">
				<div
					className={clsx(
						"w-full border-[2px] border-l-0 border-r-0 border-t-0 border-[#F4F2F6] py-[12px] transition-all",
						{
							"border-b-[#2BB792]": selectedTab === MOBILE_TABS.JOB_DETAILS,
						}
					)}
					onClick={() => handleTabClick(MOBILE_TABS.JOB_DETAILS)}
				>
					<p
						className={clsx("m-0 text-sm font-normal leading-[20px]", {
							"font-semibold": selectedTab === MOBILE_TABS.JOB_DETAILS,
						})}
					>
						Job Details
					</p>
				</div>
				{jobDetails?.interview_details?.heading && (
					<div
						className={clsx(
							"w-full border-[2px] border-l-0 border-r-0 border-t-0 border-[#F4F2F6] py-[12px] transition-all",
							{
								"border-b-[#2BB792]":
									selectedTab === MOBILE_TABS.INTERVIEW_DETAILS,
							}
						)}
						onClick={() => handleTabClick(MOBILE_TABS.INTERVIEW_DETAILS)}
					>
						<p
							className={clsx("m-0 text-sm font-normal leading-[20px]", {
								"font-semibold":
									selectedTab === MOBILE_TABS.INTERVIEW_DETAILS,
							})}
						>
							{isWalkInJob ? "Walk-in Details" : "Interview Details"}
						</p>
					</div>
				)}
				{isMobileView ? (
					<>
						{similarJobsJoading ? (
							<div className="flex w-full items-center justify-center">
								<CircularProgress
									style={{
										color: "#1F8268",
										height: "20px",
										width: "20px",
									}}
								/>
							</div>
						) : (
							<>
								{similarJobs?.length ? (
									<div
										className={clsx(
											"w-full border-[2px] border-l-0 border-r-0 border-t-0 border-[#F4F2F6] py-[12px] transition-all",
											{
												"border-b-[#2BB792]":
													selectedTab ===
													MOBILE_TABS.SIMILAR_JOBS,
											}
										)}
										onClick={() =>
											handleTabClick(MOBILE_TABS.SIMILAR_JOBS)
										}
									>
										<p
											className={clsx(
												"m-0 text-sm font-normal leading-[20px]",
												{
													"font-semibold":
														selectedTab ===
														MOBILE_TABS.SIMILAR_JOBS,
												}
											)}
										>
											Similar Jobs
										</p>
									</div>
								) : (
									""
								)}
							</>
						)}
					</>
				) : (
					""
				)}
			</div>
			<div ref={jobDetailsRef} className="md:space-y-[16px]">
				{showJobHighLightsSection && (
					<div className="bg-white p-[16px] md:pb-0 md:pl-[16px] md:pr-[16px] md:pt-[16px]">
						<JobHighlightsCard
							jobDetails={jobDetails}
							handleSeeMoreWalkInDetailsClick={() =>
								handleTabClick(MOBILE_TABS.INTERVIEW_DETAILS)
							}
						/>
					</div>
				)}
				{showFeeChargeSection && (
					<div className="md:mt-[16px]">
						<FeeChargeCard jobDetails={jobDetails} />
					</div>
				)}
				{showdivider && (
					<div className="mx-auto mt-[24px] hidden h-[1px] w-[95%] bg-[#E8E7EA] md:block" />
				)}
				{/* Job Description Section */}
				{jobDetails?.rich_description && (
					<>
						<div
							className={clsx("mb-[8px] bg-white md:py-0", {
								"p-[16px]": jobDetails?.description,
							})}
						>
							<JobDescription
								jobDetail={jobDetails}
								jobDescription={jobDescription}
								shortJobDescription={shortJobDescription}
							/>
						</div>
						<div className="px-[16px]">
							<Divider />
						</div>
					</>
				)}

				{Array.isArray(jobDetails?.job_details_section) &&
					jobDetails?.job_details_section?.map((section) => (
						<div
							className="mb-[8px] bg-white p-[16px] md:py-0"
							ref={
								section?.id === "interview_details" ||
								section?.id === "walk_in"
									? interviewDetailsRef
									: null
							}
						>
							<p className="mb-[4px] text-md font-semibold md:mb-[8px]">
								{section?.heading}
							</p>
							{!(isJobApplied && section?.id === "walk_in") && (
								<p className="mb-[16px] text-[12px] leading-[16px] text-[#8C8594] md:mb-[12px] md:text-[14px] md:leading-[20px]">
									{section?.sub_heading}
								</p>
							)}
							{/* Walk In Eligible/Ineligible Nudge */}
							{isWalkInJob && isJobApplied && section?.id === "walk_in" && (
								<div>
									{!isCandidateEligible && (
										<div
											className="mb-[16px] flex w-full cursor-pointer gap-[12px] rounded-[8px]  border border-solid border-[#f7e07e4c] bg-gradient-to-r from-[#fff9db00] to-[#FFF9DB] p-[12px]"
											onClick={() => handleWalkInNudgeClick()}
										>
											<InfoIcon fill="#AA4900" />
											<div onClick={() => handleWalkInNudgeClick()}>
												<p className="m-0 text-[12px] leading-[16px] text-[#AA4900] md:text-[14px] md:leading-[20px]">
													Your profile does not match the job
													requirements.&nbsp;
													<span
														className={clsx(
															"m-0 cursor-pointer text-[12px] font-semibold leading-[16px]  text-[#AA4900] md:text-[14px] md:leading-[20px]"
														)}
													>
														Know more
													</span>
												</p>
											</div>
										</div>
									)}
									{/* Walk in eligible nudge */}
									{isCandidateEligible && (
										<div
											className="mb-[16px] flex w-full cursor-pointer items-center gap-[12px] rounded-[8px] bg-[#C1DBFB] p-[10px]"
											onClick={() => handleWalkInNudgeClick()}
										>
											<LightBulbIcon />
											<div className="flex w-full flex-1 items-center justify-between">
												<p className="m-0 text-[12px] font-semibold leading-[16px] text-[#172B4D] md:text-[14px] md:leading-[20px]">
													Tips before going for the interview
												</p>
												<div className="rotate-180">
													<ChevronLeftIcon fill="#004BA9" />
												</div>
											</div>
										</div>
									)}
								</div>
							)}
							<div
								className={`grid grid-cols-1 gap-[12px]
										${
											section?.id === "walk_in" ||
											section?.id === "interview_details" ||
											section?.id === "about_company"
												? "md:grid-cols-1"
												: "md:grid-cols-2"
										}
								`}
							>
								{Array.isArray(section?.data) &&
									section?.data?.length > 0 &&
									section?.data?.map((data) => (
										<div className="flex w-full space-x-[8px]">
											<div className="mt-[2px] md:mt-[3px]">
												<Image
													src={data?.icon?.link}
													alt=""
													height={data?.icon?.height || 24}
													width={data?.icon?.width || 24}
												/>
											</div>
											<div className="flex-1">
												<p className="m-0 text-sm leading-[20px] text-[#8C8594] md:leading-[24px]">
													{data?.title}
												</p>
												<p className="m-0 text-sm leading-[20px] text-[#190A28] md:leading-[24px]">
													{data?.subtitle}
												</p>
											</div>
										</div>
									))}
							</div>
							<Divider />
						</div>
					))}

				{jobDetails?.organization?.name && (
					<div className="mb-[8px] bg-white p-[16px] md:pb-[16px] md:pl-[16px] md:pr-[16px] md:pt-0">
						<p className="md:font-md m-0 text-sm text-[#8C8594] md:leading-[24px]">
							Job posted by{" "}
							<span className="font-semibold text-[#190A28]">
								{jobDetails?.organization?.name}
							</span>
						</p>
					</div>
				)}
			</div>
			{isMobileView && !isExternalJob && (
				<div className="rounded-0 mb-[16px] w-full max-w-[655px] bg-white p-[24px]">
					<div className="flex justify-between">
						<div className="flex items-center justify-between">
							<div className="text-[16px] font-bold">
								FAQs about this job
							</div>
						</div>
						<div>
							{showQNASection ? (
								<p
									onClick={() => setShowQNASection(false)}
									className="align-center m-0 flex cursor-pointer items-center justify-center text-[14px] font-semibold leading-[20px] text-[#1F8268]"
								>
									Hide all
									<DownArrow className="ml-[4px] h-[16px] w-[16px] rotate-180 fill-[#1F8268]" />
								</p>
							) : (
								<p
									onClick={() => setShowQNASection(true)}
									className="align-center m-0 flex cursor-pointer items-center justify-center text-[14px] font-semibold leading-[20px] text-[#1F8268]"
								>
									Show all
									<DownArrow className="ml-[4px] h-[16px] w-[16px] fill-[#1F8268]" />
								</p>
							)}
						</div>
					</div>
					{showQNASection && <FAQs faqs={getJobsQNA(jobDescriptionTemplate)} />}
				</div>
			)}
			{similarJobs?.length && isMobileView ? (
				<div className="mb-[8px] bg-white md:py-0" ref={similarJobsRef}>
					<SimilarJobsSection
						similarJobs={similarJobs}
						category={category}
						similarJobsJoading={similarJobsJoading}
					/>
				</div>
			) : (
				""
			)}
		</div>
	);
};
export default JobDetailsSection;
